const DEFAULT_CURRENCY_CODE = "INR";

const COUNTRY_TO_CURRENCY = {
  IN: "INR",
  US: "USD",
  GB: "GBP",
  CA: "CAD",
  AU: "AUD",
  NZ: "NZD",
  SG: "SGD",
  AE: "AED",
  SA: "SAR",
  QA: "QAR",
  KW: "KWD",
  OM: "OMR",
  BH: "BHD",
  JP: "JPY",
  CN: "CNY",
  KR: "KRW",
  TH: "THB",
  MY: "MYR",
  ID: "IDR",
  PH: "PHP",
  VN: "VND",
  HK: "HKD",
  DE: "EUR",
  FR: "EUR",
  IT: "EUR",
  ES: "EUR",
  NL: "EUR",
  BE: "EUR",
  IE: "EUR",
  PT: "EUR",
  AT: "EUR",
  FI: "EUR",
  GR: "EUR",
  LU: "EUR",
  MT: "EUR",
  CY: "EUR",
};

const COUNTRY_NAME_TO_CODE = {
  INDIA: "IN",
  "UNITED STATES": "US",
  "UNITED STATES OF AMERICA": "US",
  USA: "US",
  "UNITED KINGDOM": "GB",
  UK: "GB",
  CANADA: "CA",
  AUSTRALIA: "AU",
  GERMANY: "DE",
  FRANCE: "FR",
  ITALY: "IT",
  SPAIN: "ES",
  NETHERLANDS: "NL",
  IRELAND: "IE",
  JAPAN: "JP",
  CHINA: "CN",
  SINGAPORE: "SG",
  "UNITED ARAB EMIRATES": "AE",
};

const normalizeCountryCode = (country) => {
  if (!country || typeof country !== "string") return null;

  const trimmed = country.trim();
  if (!trimmed) return null;

  if (trimmed.length === 2) {
    return trimmed.toUpperCase();
  }

  const upperName = trimmed.toUpperCase();
  return COUNTRY_NAME_TO_CODE[upperName] || null;
};

export const getCurrencyCodeFromCountry = (country) => {
  const countryCode = normalizeCountryCode(country);
  if (!countryCode) return DEFAULT_CURRENCY_CODE;
  return COUNTRY_TO_CURRENCY[countryCode] || DEFAULT_CURRENCY_CODE;
};

export const getResolvedCurrencyCode = ({ country, currencyCode } = {}) => {
  if (currencyCode && typeof currencyCode === "string") {
    return currencyCode.toUpperCase();
  }

  if (country) {
    return getCurrencyCodeFromCountry(country);
  }

  return DEFAULT_CURRENCY_CODE;
};

export const formatCurrency = (amount, options = {}) => {
  const numericAmount = Number(amount);
  if (Number.isNaN(numericAmount)) return "-";

  const currencyCode = getResolvedCurrencyCode(options);
  const locale = options.locale || "en-IN";

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits:
      typeof options.minimumFractionDigits === "number"
        ? options.minimumFractionDigits
        : 2,
    maximumFractionDigits:
      typeof options.maximumFractionDigits === "number"
        ? options.maximumFractionDigits
        : 2,
  }).format(numericAmount);
};

export const getCurrencySymbol = (options = {}) => {
  const currencyCode = getResolvedCurrencyCode(options);
  const locale = options.locale || "en-IN";

  const parts = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).formatToParts(0);

  const symbolPart = parts.find((part) => part.type === "currency");
  return symbolPart ? symbolPart.value : "₹";
};

export { DEFAULT_CURRENCY_CODE };
